export const BASE_CLASS = 'fullslip';
export const RECEIPT_BASE_CLASS = `${BASE_CLASS}__receipt`;
export const CAST_MARKETS = ['forecast', 'tricast' ];
export const SINGLE_RECEIPT_BET_TYPES = ['singles', 'scorecast', ...CAST_MARKETS];
